'use es6';

import * as ViewerCache from '../utils/ViewerCache';
export default (actionType => () => next => action => {
  if (action.type === actionType) {
    ViewerCache.set(action.payload.toJS());
  }

  return next(action);
});